import {
  RegionalHighlightAddressMatchReason,
  RegionalHighlightListingMatchAction,
  type RegionalHighlightSlot,
  type RegionalHighlightSlotsResponse,
} from '@/types/regionalHighlight';

export type RegionalHighlightDraftState =
  | { kind: 'hidden' }
  | { kind: 'no-usable-slot' }
  | { kind: 'assignable'; slot: RegionalHighlightSlot }
  | { kind: 'blocked'; slot: RegionalHighlightSlot };

const isVisibleBlockedSlot = (slot: RegionalHighlightSlot): boolean =>
  slot.addressMatch?.assignable === false &&
  slot.addressMatch.reason !== RegionalHighlightAddressMatchReason.ADDRESS_INELIGIBLE &&
  slot.addressMatch.reason !== RegionalHighlightAddressMatchReason.DISTRICT_MISMATCH;

/**
 * Maps an address-preview response into the RH state offered by the new-listing wizard.
 * Creation can consume a free slot but never replaces an existing listing's booking.
 */
export const getRegionalHighlightDraftState = (
  response: RegionalHighlightSlotsResponse | undefined,
): RegionalHighlightDraftState => {
  if (!response?.address?.eligible) {
    return { kind: 'hidden' };
  }

  const assignableSlot = response.slots.find(
    (slot) =>
      slot.addressMatch?.assignable === true &&
      slot.addressMatch.action === RegionalHighlightListingMatchAction.ASSIGN,
  );
  if (assignableSlot) {
    return { kind: 'assignable', slot: assignableSlot };
  }

  const blockedSlot = response.slots.find(isVisibleBlockedSlot);
  if (blockedSlot) {
    return { kind: 'blocked', slot: blockedSlot };
  }

  return { kind: 'no-usable-slot' };
};
